export default {
  nav: {
    bottomNav: {
      home: 'ផ្ទះ',
      record: 'កត់ត្រា',
      calendar: 'ប្រតិទិន',
      vevo: 'VEVO',
      settings: 'ការកំណត់',
    },
  },
  vevo: {
    reportFallback: 'របាយការណ៍',
    intro: {
      greeting: 'ជូនចំពោះមាតាបិតា',
      line1: 'នៅទីនេះ យើងនឹងចែករំលែក',
      line2: 'ការលូតលាស់ប្រចាំថ្ងៃរបស់កូនអ្នក',
      line3: 'រៀងរាល់ 3 ខែម្តង!',
    },
    listTitle: 'បញ្ជីរបាយការណ៍',
    empty: {
      line1: 'មិនទាន់មានរបាយការណ៍នៅឡើយទេ។',
      line2: 'សូមរង់ចាំត្រីមាសបន្ទាប់!',
    },
    publishedAt: 'ចេញផ្សាយ {date}',
    detail: {
      title: 'របាយការណ៍ VEVO',
      notFound: 'រកមិនឃើញរបាយការណ៍ទេ។',
      monthRange: 'ខែ {start} ដល់ខែ {end}',
      coverageNote: 'របាយការណ៍នេះត្រូវបានបង្កើតពីទិន្នន័យដែលមានក្នុង {range}។',
      caution: '※ អត្ថបទនេះត្រូវបានបង្កើតឡើងដោយផ្អែកលើការលូតលាស់របស់កូនអ្នកដែលគ្រូបានពិនិត្យ ប៉ុន្តែអាចមានព័ត៌មានមិនត្រឹមត្រូវ ដោយសារភាពខុសគ្នានៃការបកស្រាយទិន្នន័យដោយ AI។',
      language: 'ភាសាបង្ហាញ',
      languages: {
        en: 'English',
        ja: 'Japanese',
        km: 'Khmer',
        vi: 'Tiếng Việt',
        ko: 'Korean',
        zh: 'Chinese',
        hi: 'Hindi',
        ru: 'Russian',
        bn: 'Bengali',
        mn: 'Mongolian',
        tl: 'Tagalog',
        ms: 'Malay',
      },
    },
  },
  validation: {
    required: 'វាលនេះត្រូវបានទាមទារ',
    choice2: 'សូមជ្រើសរើសជម្រើស 2',
    counter: 'សូមបញ្ចូលក្នុងចន្លោះ 20 តួអក្សរ',
    counter2: 'សូមបញ្ចូល 2 តួអក្សរ',
    counter3: 'សូមបញ្ចូល 3 តួអក្សរ',
    counterMin4: 'សូមបញ្ចូលក្នុង 4 តួអក្សរ',
    counter14to16: 'សូមបញ្ចូល 14-16 តួអក្សរ',
    counter100: 'សូមបញ្ចូលក្នុង 100 តួអក្សរ',
    counter500: 'សូមបញ្ចូលក្នុងចន្លោះ 500 តួអក្សរ',
    counter1000: 'សូមបញ្ចូលក្នុង 1000 តួអក្សរ',
    typeNumber: 'សូមបញ្ចូលលេខត្រឹមត្រូវ។',
    typeStringNumber: 'សូមបញ្ចូលលេខត្រឹមត្រូវ។',
    email: 'សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ។',
    phoneNumber: 'ទម្រង់លេខទូរស័ព្ទមិនត្រឹមត្រូវ',
    postalCode: 'ទម្រង់កូដប្រៃសណីយ៍មិនត្រឹមត្រូវ',
    integerThan0: 'សូមបញ្ចូលចំនួនគត់មិនអវិជ្ជមាន',
    multipleSelectRequired: 'វាលនេះត្រូវបានទាមទារ',
    typeKana: 'សូមបញ្ចូលក្នុងកាតាកាណា',
    typeKanaFullWidth: 'សូមបញ្ចូល Katakana ពេញទទឹង',
    typeHiraganaFullWidth: 'សូមបញ្ចូល ហ៊ីរ៉ាហ្គាណា ពេញទទឹង',
    typeAlphabet: 'សូមបញ្ចូលអក្សរពាក់កណ្តាលទទឹង',
  },
  setting: {
    growth: 'កំណត់ត្រាកំណើន',
    invoice: 'វិក្កយបត្រ',
    variousSettings: 'ការកំណត់ផ្សេងៗ',
    familySettings: 'ការកំណត់គ្រួសារ',
    paymentSettings: 'ការកំណត់ការទូទាត់',
    notificationSettings: 'ការកំណត់ការជូនដំណឹង',
    languageSettings: 'ជ្រើសរើសភាសា',
    logout: 'ចេញ',
  },
  settingLanguage: {
    title: 'ជ្រើសរើសភាសា',
    save: 'រក្សាទុក',
    successMessage: 'ការកំណត់ភាសាត្រូវបានរក្សាទុក',
    languages: {
      english: 'English (ភាសាអង់គ្លេស)',
      khmer: 'ភាសាខ្មែរ',
      japanese: '日本語 (ជប៉ុន)',
    },
  },
  invoice: {
    selectTitle: 'វិក្កយបត្រ',
  },
  settingFamily: {
    title: 'ការកំណត់គ្រួសារ',
    guardians: 'អាណាព្យាបាល',
    you: 'អ្នក',
    inviteGuardian: 'អញ្ជើញអាណាព្យាបាលម្នាក់ទៀត។',
    children: 'កុមារ',
    addChild: 'បន្ថែមកូន',
    familyInfo: 'ព័ត៌មានគ្រួសារ',
    parentType: {
      mother: 'ម្តាយ',
      father: 'ឪពុក',
      grandma: 'យាយ',
      granpa: 'ជីតា',
      uncle: 'ពូ',
      aunt: 'មីង',
      sister: 'បងស្រី',
      brother: 'បងប្រុស',
      other: 'ផ្សេងៗ',
    },
  },
  parentEdit: {
    save: 'រក្សាទុក',
    lastName: 'នាមត្រកូល',
    firstName: 'ឈ្មោះដំបូង',
    lastNameKana: 'នាមត្រកូល (កាណា)',
    firstNameKana: 'ឈ្មោះដើម (កាណា)',
    deleteAccount: 'លុបគណនីអាណាព្យាបាលនេះ។',
    successMessage: 'ការចុះឈ្មោះបានបញ្ចប់',
    bloodType: {
      a: 'ប្រភេទមួយ។',
      b: 'ប្រភេទ ខ',
      o: 'ប្រភេទ O',
      ab: 'ប្រភេទ AB',
      unknown: 'មិនស្គាល់',
    },
  },
  parentAdd: {
    title: 'អញ្ជើញគ្រួសារ',
    emailLabel: 'អាសយដ្ឋានអ៊ីមែល',
    parentTypeLabel: 'ប្រភេទអាណាព្យាបាល',
    noticeSignup: '*អ្នកដែលបានអញ្ជើញត្រូវតែចុះឈ្មោះដោយប្រើអាសយដ្ឋានអ៊ីមែលដែលបានបញ្ចូលខាងលើ។',
    noticeSpam: '*ការចុះឈ្មោះ (ចុះឈ្មោះ) គឺអាចធ្វើទៅបាន ទោះបីជាអ៊ីមែលអញ្ជើញត្រូវបានត្រងជាសារឥតបានការក៏ដោយ។',
    submit: 'ផ្ញើ',
    invitedEmails: 'អាសយដ្ឋានអ៊ីមែលដែលបានអញ្ជើញ',
    inviteSuccess: 'ការអញ្ជើញបានបញ្ចប់',
    parentType: {
      mother: 'ម្តាយ',
      father: 'ឪពុក',
      grandma: 'យាយ',
      granpa: 'ជីតា',
      uncle: 'ពូ',
      aunt: 'មីង',
      other: 'ផ្សេងៗ',
    },
  },
  childEdit: {
    processing: 'ដំណើរការ។ សូមរង់ចាំ...',
    save: 'រក្សាទុក',
    lastName: 'នាមត្រកូល',
    firstName: 'ឈ្មោះដំបូង',
    lastNameKana: 'នាមត្រកូល (កាណា)',
    firstNameKana: 'ឈ្មោះដើម (កាណា)',
    successMessage: 'រក្សាទុកដោយជោគជ័យ',
  },
  childrenGrowth: {
    save: 'រក្សាទុក',
    successMessage: 'ការចុះឈ្មោះបានបញ្ចប់',
  },
  childAdd: {
    title: 'បន្ថែមកូន',
    childIdLabel: "លេខសម្គាល់កុមារ",
    password: 'ពាក្យសម្ងាត់',
    submit: 'បន្ថែមកូន',
    successMessage: 'ការចុះឈ្មោះបានបញ្ចប់',
  },
  meCreate: {
    tapToChange: 'ប៉ះដើម្បីផ្លាស់ប្តូរ',
    lastName: 'នាមត្រកូល',
    firstName: 'ឈ្មោះដំបូង',
    lastNameKana: 'នាមត្រកូល (កាណា)',
    firstNameKana: 'ឈ្មោះដើម (កាណា)',
    birthDate: 'ថ្ងៃខែឆ្នាំកំណើត',
    bloodType: 'ប្រភេទឈាម',
    phoneNumber: 'លេខទូរស័ព្ទ',
    submit: 'ដាក់ស្នើ',
  },
  familyCreate: {
    description: {
      line1: 'អេក្រង់នេះលេចឡើងនៅពេលចុះឈ្មោះជាមួយកុមារជាលើកដំបូង។',
      line2: 'ប្រសិនបើអ្នកធ្លាប់ប្រើ CCSHOME ពីមុនមក អ្នកកំពុងព្យាយាមចូលដោយប្រើអាសយដ្ឋានអ៊ីមែលខុសពីអាសយដ្ឋានដែលបានប្រើអំឡុងពេលចុះឈ្មោះដំបូង។',
      line3: 'សូម​ចុច​ចេញ​ម្តង រួច​ចូល​ដោយ​ប្រើ​គណនី និង​វិធី​ចូល​ដែល​ប្រើ​ក្នុង​ពេល​ចុះឈ្មោះ​ដំបូង។',
      line4: 'ប្រសិនបើនេះគឺជាការចុះឈ្មោះដំបូងរបស់អ្នក សូមបញ្ចូលលេខសម្គាល់កុមារ និងពាក្យសម្ងាត់ដែលមាននៅក្នុងសេចក្តីជូនដំណឹងខាងក្រោម។',
    },
    childId: "លេខសម្គាល់កុមារ",
    password: 'ពាក្យសម្ងាត់',
    parentType: 'ប្រភេទអាណាព្យាបាល',
    submit: 'ផ្ញើ',
    logout: 'ចេញ',
  },
  familyEdit: {
    title: 'កែសម្រួលព័ត៌មានគ្រួសារ',
    familyName: 'ឈ្មោះគ្រួសារ',
    save: 'រក្សាទុក',
    successMessage: 'ការចុះឈ្មោះបានបញ្ចប់',
  },
  settingNotification: {
    title: 'ការកំណត់ការជូនដំណឹង',
    save: 'រក្សាទុក',
    successMessage: 'ការចុះឈ្មោះបានបញ្ចប់',
    options: {
      both: 'ទាំងពីរ',
      pushOnly: 'រុញតែប៉ុណ្ណោះ',
      emailOnly: 'អ៊ីមែលតែប៉ុណ្ណោះ',
      none: 'គ្មាន',
    },
    notifications: {
      absentConfirmed: 'ការជូនដំណឹងអវត្តមាន',
      pickupConfirmed: 'ការផ្លាស់ប្តូរទៅយក',
      pickupConfirmedTitle: 'ការផ្លាស់ប្តូរការទទួលត្រូវបានបញ្ជាក់ហើយ!',
      chatReceived: 'ជជែក',
      chatReceivedTitle: 'មានសារថ្មីមកដល់!',
      growthUpdated: 'ការធ្វើបច្ចុប្បន្នភាពកំណត់ត្រាកំណើន',
      invoiceSettled: 'បានចេញវិក្កយបត្រ',
      creditSettled: 'ការគិតថ្លៃកាតឥណទាន',
      creditFailed: 'ការគិតប្រាក់តាមកាតឥណទានបានបរាជ័យ',
    },
  },
  growth: {
    memory: 'កត់ត្រា',
    graph: 'ក្រាហ្វ',
    nendo: 'ឆ្នាំ',
    implementationMonth: 'ខែ',
    height: 'កម្ពស់',
    weight: 'ទម្ងន់',
    noData: 'មិនមានទិន្នន័យទេ។',
    show: 'បង្ហាញ',
    remarks: 'សុន្ទរកថា',
    close: 'បិទ',
    percentileRange: 'តម្លៃភាគរយក្នុងជួរ 3% ~ 97%',
  },
  calendar: {
    prevMonth: 'ខែមុន។',
    nextMonth: 'ខែក្រោយ',
    dateFormat: '{month}/{day}',
    dateFormatFull: '{year}/{month}/{day} ({dayOfWeek})',
    monthName: '{month}',
    defecation: {
      hard: 'រឹង',
      normal: 'ធម្មតា។',
      soft: 'ទន់',
      diarrhea: 'ទឹក (រាគ)',
    },
  },
  home: {
    loadingReleaseInfo: 'កំពុងផ្ទុកព័ត៌មានចេញផ្សាយ...',
    loadMore: 'ផ្ទុកច្រើនទៀត',
    newAnnouncement: 'អ្នកមានសេចក្តីប្រកាសថ្មី!',
    fabReleaseInfo: 'ចេញផ្សាយព័ត៌មាន',
    fabAbsence: 'ការជូនដំណឹងអវត្តមាន',
    fabPickup: 'ការផ្លាស់ប្តូរទៅយក',
    qrBarcodeHint: 'សង្កត់បាកូដខាងលើលើឧបករណ៍ដែលឧទ្ទិស។',
  },
  common: {
    cancel: 'បោះបង់',
    submit: 'ផ្ញើ',
    delete: 'លុប',
    unknown: 'មិនស្គាល់',
  },
  emailSendModal: {
    title: 'បញ្ជាក់អ្នកទទួលអ៊ីមែល',
    emailLabel: 'អាសយដ្ឋានអ៊ីមែលអ្នកទទួល',
    notice: {
      line1: '* ឯកសារភ្ជាប់នឹងត្រូវបានផ្ញើតាមអ៊ីមែល។',
      line2: '* សូមប្រាកដថាអាសយដ្ឋានអ្នកទទួលត្រឹមត្រូវ។',
    },
    cancel: 'បោះបង់',
    submit: 'ផ្ញើអ៊ីមែល',
    success: 'អ៊ីមែលត្រូវបានផ្ញើដោយជោគជ័យ',
    errors: {
      unavailable: 'សូមអភ័យទោស មុខងារនេះមិនអាចប្រើបាននៅពេលនេះទេ។',
      emailRequired: 'អាសយដ្ឋានអ៊ីមែលមិនត្រូវបានបញ្ចូលទេ។',
    },
  },
  translationModal: {
    title: 'ជ្រើសរើសភាសា',
    cancel: 'បោះបង់',
    submit: 'បកប្រែ',
    success: 'បកប្រែបានជោគជ័យ',
    failure: 'បកប្រែមិនបានសម្រេច',
  },
  accountDelete: {
    title: 'ព្រមាន!',
    description: {
      line1: 'ប្រសិនបើអ្នកលុបគណនីរបស់អ្នក អ្នកនឹងមិនអាចចូលដោយប្រើគណនីនេះទៀតទេ ហើយព័ត៌មានខាងក្រោមទាំងអស់នឹងត្រូវបាត់បង់។',
      line2: '* អ្នកក៏នឹងមិនអាចចូល MEMORU បានទេ។',
    },
    items: {
      records: 'កំណត់ត្រាទាំងអស់នៅក្នុងសៀវភៅកត់ត្រាទំនាក់ទំនង',
      chat: 'ប្រវត្តិជជែក',
      growth: 'ទិន្នន័យកំណត់ត្រាកំណើនទាំងអស់។',
      invoices: 'វិក្កយបត្រដែលបានទទួលទាំងអស់។',
      memoru: 'ទិន្នន័យ MEMORU ទាំងអស់។',
    },
    continue: 'បន្ត',
    reasonPrompt: 'សូមបញ្ចូលហេតុផលសម្រាប់ការលុប។',
  },
  record: {
    menu: {
      chat: 'ជជែក',
      todayRecord: "កំណត់ត្រាថ្ងៃនេះ",
      references: 'សេចក្តីជូនដំណឹង/ធនធាន',
      vevo: 'របាយការណ៍ VEVO',
    },
    date: {
    yearSuffix: '{year}',
    month: '{month}',
      monthDay: '{day}/{month}',
      prevDay: 'ថ្ងៃមុន',
      nextDay: 'ថ្ងៃបន្ទាប់',
      prevMonth: 'ខែមុន។',
      nextMonth: 'ខែក្រោយ',
      editedAt: '(បានកែសម្រួល {time})',
    },
    section: {
      nurseryRecord: 'កំណត់ត្រាបណ្តុះកូន',
      homeRecord: 'កំណត់ត្រាផ្ទះ',
      attendance: 'ពេលវេលាចូលរួម',
      sleep: 'គេង',
      meal: 'អាហារ',
      mealComment: 'មតិយោបល់',
      defecation: 'ការបន្ទោរបង់',
      milk: 'ទឹកដោះគោ',
      temperature: 'សីតុណ្ហភាព',
      breakfast: 'អាហារពេលព្រឹក',
      dinner: 'អាហារពេលល្ងាច',
      childRecord: "កំណត់ចំណាំរបស់កុមារ",
    },
    meal: {
      stapleFood: 'អាហារដើម',
      mainDish: 'ម្ហូបចម្បង',
      sideDish: 'ម្ហូបចំហៀង',
      soup: 'ស៊ុប',
      dessert: 'បង្អែម',
      milk: 'ទឹកដោះគោ',
      snack: 'អាហារសម្រន់',
      commentPlaceholder: 'បញ្ចូលមតិយោបល់',
      actions: {
        finishAll: 'បញ្ចប់ទាំងអស់។',
        addRecord: '+ បន្ថែមកំណត់ត្រា',
      },
    },
    action: {
      addSleep: 'បន្ថែមកំណត់ត្រាគេង',
      addTemperature: 'បន្ថែមកំណត់ត្រាសីតុណ្ហភាព',
      addBreakfast: 'បន្ថែមកំណត់ត្រាអាហារពេលព្រឹក',
      addDinner: 'បន្ថែមកំណត់ត្រាអាហារពេលល្ងាច',
      addMilk: 'បន្ថែមកំណត់ត្រាទឹកដោះគោ',
      addDefecation: 'បន្ថែមកំណត់ត្រានៃការបន្ទោរបង់',
      saveDraft: 'រក្សាទុកសេចក្តីព្រាង',
    },
    status: {
      milkFormula: 'រូបមន្ត',
      milkBreast: 'ទឹកដោះម្តាយ',
      defecationHard: 'រឹង',
      defecationNormal: 'ធម្មតា។',
      defecationSoft: 'ទន់',
      defecationDiarrhea: 'ទឹក (រាគ)',
      mealRefill: 'បំពេញ',
      mealFinished: 'ចប់',
      mealUnfinished: 'ទុកខ្លះ',
      mealHalf: 'ពាក់កណ្តាល',
      mealLittle: 'បន្តិច',
      mealNotEat: 'មិនបានបរិភោគ',
      mealNotServed: 'មិនបានបម្រើ',
    },
    modal: {
      sleepTitle: 'គេង',
      sleepStart: 'ចាប់ផ្តើម',
      sleepEnd: 'ចប់',
      breakfastTitle: 'អាហារពេលព្រឹក',
      dinnerTitle: 'អាហារពេលល្ងាច',
      milkTitle: 'ទឹកដោះគោ',
      milkTime: 'ពេលវេលា',
      milkType: 'ប្រភេទ',
      milkAmount: 'ចំនួនទឹកប្រាក់',
      defecationTitle: 'ការបន្ទោរបង់',
      defecationTime: 'ពេលវេលា',
      defecationState: 'លក្ខខណ្ឌ',
      temperatureTitle: 'សីតុណ្ហភាព',
      temperatureTime: 'ពេលវេលា',
      temperatureValue: 'សីតុណ្ហភាព',
    },
    confirm: {
      deleteRecord: 'លុបកំណត់ត្រានេះ?',
    },
    toast: {
      deleted: 'បានលុបដោយជោគជ័យ',
      updated: 'បានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ',
    },
  },
  references: {
    datePicker: {
      title: 'ជ្រើសរើសឆ្នាំនិងខែ',
      year: 'ឆ្នាំ',
      month: 'ខែ',
      apply: 'អនុវត្ត',
    },
    detail: {
      date: 'កាលបរិច្ឆេទ',
      title: 'ចំណងជើង',
      body: 'រាងកាយ',
      attachments: 'ឯកសារភ្ជាប់',
      view: 'មើល',
      iframeNotSupported: 'កម្មវិធីរុករកតាមអ៊ីនធឺណិតរបស់អ្នកមិនគាំទ្រ iframes ទេ។',
      downloadPdf: 'ទាញយក PDF',
      close: 'បិទ',
    },
  },
  chat: {
    header: {
      record: 'កត់ត្រា',
      prevDay: 'ថ្ងៃមុន',
      nextDay: 'ថ្ងៃបន្ទាប់',
      year: '{year}',
    },
    tabs: {
      chat: 'ជជែក',
      absence: 'ការជូនដំណឹងអវត្តមាន',
      pickup: 'មកយក',
    },
    menu: {
      delete: 'លុប',
      copy: 'ចម្លង',
    },
    message: {
      read: 'អាន',
      groupChatLabel: '[សេចក្តីប្រកាស]\n',
      showAttachment: 'បង្ហាញឯកសារភ្ជាប់',
      sendAttachmentByEmail: 'ផ្ញើឯកសារភ្ជាប់តាមអ៊ីមែល',
    },
    input: {
      send: 'ផ្ញើ',
    },
    absence: {
      title: 'ការជូនដំណឹងអវត្តមាន',
      reasons: {
        fever: 'គ្រុន',
        personal: 'ហេតុផលគ្រួសារ',
        infection: 'ជំងឺឆ្លង',
        others: 'ផ្សេងៗ',
        othersWithComment: 'ផ្សេងទៀត (ត្រូវការមតិយោបល់)',
        infStrep: 'រលាកបំពង់ក',
        infMycoplasma: 'ជំងឺរលាកសួត ម៉ាយកូផ្លាស្មា',
        infHFMD: 'ជំងឺដៃ ជើង និងមាត់',
        infSlappedCheek: 'ជំងឺទីប្រាំ (ទះកំផ្លៀង)',
        infStomach: 'មេរោគរលាកក្រពះពោះវៀន (ណូរ៉ូវីរុស, រ៉ូតាវីរុស, អាឌេណូវីរុស ជាដើម)',
        infHerpangina: 'ហឺប៉ង់ហ្គីណា',
        infRS: 'ការឆ្លងមេរោគ RS',
        infZoster: 'ជំងឺរើម',
        infRoseola: 'រ៉ូសអូឡា',
        infImpetigo: 'ទឹករំអិល',
        covid19: 'COVID 19',
      },
    },
    absenceModal: {
      title: 'ការជូនដំណឹងអវត្តមាន',
      fields: {
        period: 'រយៈពេល',
        reason: 'ហេតុផល',
        detail: 'ព័ត៌មានលម្អិត',
        comment: 'មតិយោបល់',
      },
      actions: {
        ok: 'យល់ព្រម',
      },
      reasons: {
        fever: 'គ្រុន',
        personal: 'ហេតុផលគ្រួសារ',
        infection: 'ជំងឺឆ្លង',
        others: 'ផ្សេងទៀត (ត្រូវការមតិយោបល់)',
      },
      infections: {
        infStrep: 'រលាកបំពង់ក',
        infMycoplasma: 'ជំងឺរលាកសួត ម៉ាយកូផ្លាស្មា',
        infHFMD: 'ជំងឺដៃ ជើង និងមាត់',
        infSlappedCheek: 'ជំងឺទីប្រាំ (ទះកំផ្លៀង)',
        infStomach: 'មេរោគរលាកក្រពះពោះវៀន (ណូរ៉ូវីរុស, រ៉ូតាវីរុស, អាឌេណូវីរុស ជាដើម)',
        infHerpangina: 'ហឺប៉ង់ហ្គីណា',
        infRS: 'ការឆ្លងមេរោគ RS',
        infZoster: 'ជំងឺរើម',
        infRoseola: 'រ៉ូសអូឡា',
        infImpetigo: 'ទឹករំអិល',
        covid19: 'COVID 19',
      },
    },
    pickup: {
      title: 'ការផ្លាស់ប្តូរទៅយក',
      dropOffBy: 'ទម្លាក់ដោយ៖',
      dropOffTime: 'ពេលវេលាចុះចត៖',
      pickupBy: 'ទទួលដោយ៖',
      pickupTime: 'ពេលវេលាទៅយក៖',
    },
    pickupModal: {
      title: 'ការផ្លាស់ប្តូរទៅយក',
      tabs: {
        dropOff: 'ទម្លាក់ចុះ',
        pickup: 'មកយក',
      },
      fields: {
        date: 'កាលបរិច្ឆេទ',
        dropOffBy: 'មនុស្សទម្លាក់',
        dropOffTime: 'ពេលវេលាចុះចត',
        pickupBy: 'មនុស្សមកយក',
        pickupTime: 'ពេលវេលាទៅយក',
        reason: 'ហេតុផល',
      },
      parentRelation: {
        Mother: 'ម្តាយ',
        Father: 'ឪពុក',
        Grandmother: 'ជីដូន',
        Grandfather: 'ជីតា',
        Uncle: 'ពូ',
        Aunt: 'មីង',
        Sister: 'ប្អូនស្រី',
        Brother: 'ប្អូនប្រុស',
        Other: 'ផ្សេងទៀត',
      },
    },
    action: {
      cancel: 'លុប',
      close: 'បិទ',
      cancelBtn: 'បោះបង់',
    },
    confirm: {
      deleteTitle: 'លុបសារនេះ?',
    },
    toast: {
      copied: 'ចម្លង',
      deleteCompleted: 'បានលុបដោយជោគជ័យ',
    },
  },
  noEmailVerified: {
    title: 'អ៊ីមែលផ្ទៀងផ្ទាត់ត្រូវបានផ្ញើរួចហើយ។',
    description: 'សូមអនុវត្តតាមជំហានខាងក្រោមដើម្បីចូលប្រើ។',
    step1: 'ចុច "ផ្ទៀងផ្ទាត់គណនី" ក្នុងអ៊ីមែល ដើម្បីបើកកម្មវិធីរុករក Chrome។',
    step2: 'ចុច "អនុញ្ញាត" លើសារដែលបានបង្ហាញ។',
    step3: 'បើកកម្មវិធី CCS HOME ហើយអេក្រង់ចុះឈ្មោះ ID និងពាក្យសម្ងាត់របស់កុមារនឹងបង្ហាញ។',
    step4: 'បន្តការចុះឈ្មោះ។',
    noEmailTitle: 'ប្រសិនបើអ្នកមិនទទួលបានអ៊ីមែល៖',
    noEmailDescription: 'សូមពិនិត្យថាអ៊ីមែលត្រូវបានតម្រៀបទៅថត Spam/Junk ដោយស្វ័យប្រវត្តិឬអត់។',
    loginButton: 'ចូល',
    reLoginButton: 'ចូលដោយប្រើគណនីផ្សេង',
  },
  error: {
    default: 'កំហុសដែលមិនបានរំពឹងទុកបានកើតឡើង។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ ឬទាក់ទងផ្នែកជំនួយអតិថិជន។',
    invalidParams: 'ប៉ារ៉ាម៉ែត្រ​មិន​ត្រឹមត្រូវ',
    tokenExpired: 'វគ្គរបស់អ្នកបានផុតកំណត់ហើយ។',
    userNotFound: 'រកមិនឃើញអ្នកប្រើប្រាស់ទេ។',
    userAlreadyExists: 'អ្នកប្រើប្រាស់នេះមានរួចហើយ។',
    invalidObjectType: 'ប្រភេទវត្ថុមិនត្រឹមត្រូវដែលបានបញ្ជាក់។',
    breakfastNotFound: 'រកមិនឃើញកំណត់ត្រាអាហារពេលព្រឹកទេ។',
    breakfastAlreadyExists: 'កំណត់ត្រាអាហារពេលព្រឹកមានរួចហើយ។',
    dinnerNotFound: 'រកមិនឃើញកំណត់ត្រាអាហារពេលល្ងាចទេ។',
    dinnerAlreadyExists: 'កំណត់ត្រាអាហារពេលល្ងាចមានរួចហើយ។',
    bowelMovementNotFound: 'រកមិនឃើញកំណត់ត្រាចលនាពោះវៀនទេ។',
    milkNotFound: 'រកមិនឃើញកំណត់ត្រាទឹកដោះគោទេ។',
    sleepNotFound: 'រកមិនឃើញកំណត់ត្រាគេងទេ។',
    temperatureNotFound: 'រកមិនឃើញកំណត់ត្រាសីតុណ្ហភាពទេ។',
    childcareJournalNotFound: 'រកមិនឃើញកំណត់ត្រាទិនានុប្បវត្តិថែទាំកុមារទេ។',
    childcareJournalAlreadyExists: 'កំណត់ត្រាទិនានុប្បវត្តិថែទាំកុមារមានរួចហើយ។',
    eatingRecordNotFound: 'រកមិនឃើញកំណត់ត្រាញ៉ាំទេ។',
    eatingRecordAlreadyExists: 'កំណត់ត្រាហូបចុកមានរួចហើយ។',
    absenceOverlap: 'មិនអាចចុះឈ្មោះបានទេ ដោយសាររយៈពេលអវត្តមានជាន់គ្នា',
    invalidReason: 'ហេតុផលដែលបានជ្រើសរើសមិនត្រឹមត្រូវទេ។',
    invalidPickedUpPerson: 'អ្នក​មក​ទទួល​ដែល​បាន​ជ្រើសរើស​មិន​ត្រឹមត្រូវ។',
    messageNotFound: 'រកមិនឃើញសារទេ។',
    pickupDataNotFound: 'រកមិនឃើញទិន្នន័យប្រមូល។',
    classNotFound: 'រកមិនឃើញថ្នាក់។',
    childNotFound: 'រកមិនឃើញកុមារ។ សូមពិនិត្យមើលលេខសម្គាល់កុមារ និងពាក្យសម្ងាត់ ហើយព្យាយាមម្តងទៀត។',
    childAlreadyRegistered: 'កុមារនេះត្រូវបានចុះឈ្មោះក្នុងគ្រួសាររបស់អ្នករួចហើយ។',
    familyNotFound: 'រកមិនឃើញគ្រួសារជាក់លាក់ទេ។',
    userNotInFamily: 'អ្នកប្រើប្រាស់មិនមែនជារបស់គ្រួសារដែលបានបញ្ជាក់ទេ។',
    userAlreadyInvited: 'អ្នកប្រើប្រាស់ដែលបានបញ្ជាក់ត្រូវបានអញ្ជើញឱ្យចូលរួមក្នុងគ្រួសាររួចហើយ។',
    formatNotFound: 'រកមិនឃើញទម្រង់ជាក់លាក់ទេ។',
    childIdNotSpecified: 'លេខសម្គាល់កុមារមិនត្រូវបានបញ្ជាក់ទេ។',
    feedInfoNotFound: 'ព័ត៌មានដែលបានបញ្ជាក់មិនមានទេ។',
    feedDetailNotFound: 'ព័ត៌មាន​លម្អិត​នៃ​មតិព័ត៌មាន​ដែល​បាន​បញ្ជាក់​មិន​មាន​ទេ។',
    reportNotOwned: 'របាយការណ៍ដែលបានបញ្ជាក់មិនមែនជារបស់អ្នកប្រើនេះទេ។',
    arrivalDepartureAlreadyExists: 'កំណត់ត្រាការមកដល់/ចេញដំណើរមានរួចហើយសម្រាប់កាលបរិច្ឆេទនេះ។',
    arrivalDepartureNotFound: 'រកមិនឃើញកំណត់ត្រាការមកដល់/ចេញដំណើរទេ។',
    arrivalRecordNotFound: 'រកមិនឃើញកំណត់ត្រាមកដល់សម្រាប់កាលបរិច្ឆេទដែលបានបញ្ជាក់។',
    arrivalRecordAlreadyExists: 'កំណត់ត្រាការមកដល់មានរួចហើយសម្រាប់កាលបរិច្ឆេទដែលបានបញ្ជាក់។',
    departureRecordAlreadyExists: 'កំណត់ត្រានៃការចាកចេញមានរួចហើយសម្រាប់កាលបរិច្ឆេទដែលបានបញ្ជាក់។',
    arrivalDepartureNotOwned: 'កំណត់ត្រាការមកដល់/ការចាកចេញនេះមិនមែនជាកម្មសិទ្ធិរបស់កុមារនេះទេ។',
    invalidNursery: 'កន្លែងបណ្តុះកូនមិនត្រឹមត្រូវបានបញ្ជាក់។',
    hiraganaCheckFailed: 'បរាជ័យក្នុងការត្រួតពិនិត្យហ៊ីរ៉ាហ្គាណា។ សូមទាក់ទងមកយើងខ្ញុំ។',
    invalidInternalId: 'លេខសម្គាល់ដែលប្រើនៅខាងក្នុងមិនត្រឹមត្រូវទេ។',
    invalidUqid: 'uqid មិន​ត្រឹមត្រូវ',
    invalidChecksum: 'Checksum មិន​ត្រឹមត្រូវ។',
    userNotInNursery: 'អ្នកប្រើប្រាស់មិនមែនជាកម្មសិទ្ធិរបស់បណ្តុះកូនដែលបានបញ្ជាក់នោះទេ។',
    adminOnly: 'មានតែអ្នកប្រើប្រាស់អ្នកគ្រប់គ្រងប៉ុណ្ណោះដែលត្រូវបានអនុញ្ញាតឱ្យធ្វើប្រតិបត្តិការនេះ។',
    invalidApprovalStatus: 'ស្ថានភាពការអនុម័តទិនានុប្បវត្តិមិនត្រឹមត្រូវទេ។',
    nurseryDiaryNotFound: 'រកមិនឃើញកំណត់ត្រាកំណត់ហេតុកុមារ',
    menuNotOwned: 'ម៉ឺនុយដែលបានបញ្ជាក់មិនមែនជាកម្មសិទ្ធិរបស់បណ្តុះកូននេះទេ។',
    userNotInNursery2: 'អ្នកប្រើប្រាស់មិនមែនជាកម្មសិទ្ធិរបស់បណ្តុះកូនដែលបានបញ្ជាក់នោះទេ។',
    adminOnly2: 'មានតែអ្នកប្រើប្រាស់អ្នកគ្រប់គ្រងប៉ុណ្ណោះដែលត្រូវបានអនុញ្ញាតឱ្យធ្វើប្រតិបត្តិការនេះ។',
    invalidApprovalStatus2: 'ស្ថានភាពការអនុម័តទិនានុប្បវត្តិមិនត្រឹមត្រូវទេ។',
    nurseryDiaryNotFound2: 'រកមិនឃើញកំណត់ត្រាកំណត់ហេតុកុមារ',
    noApprovalPermission: 'អ្នកប្រើប្រាស់នេះមិនមានការអនុញ្ញាតការយល់ព្រមទេ។',
    applicantMismatch: 'បេក្ខជននៃទិនានុប្បវត្តិនេះមិនមែនជាអ្នកប្រើប្រាស់នេះទេ។',
    journalNotPending: 'ទិនានុប្បវត្តិនេះមិនស្ថិតក្នុងស្ថានភាពរង់ចាំទេ។',
    alreadyApproved: 'អ្នកប្រើប្រាស់ផ្សេងទៀតបានយល់ព្រមរួចហើយជាមួយនឹងការអនុញ្ញាតដូចគ្នា។',
    initialJournalStatus: 'ស្ថានភាពដំបូងនៃទិនានុប្បវត្តិត្រូវតែរង់ចាំ ឬសេចក្តីព្រាង។',
    photoRecordNotFound: 'រកមិនឃើញកំណត់ត្រារូបថតទេ។',
    userNotInNursery3: 'អ្នក​ប្រើ​នេះ​មិន​មែន​ជា​កម្មសិទ្ធិ​របស់​បណ្តុះ​បណ្តាល​នៃ​ម៉ឺនុយ​ដែល​បាន​បញ្ជាក់​។',
    foodInspectionAlreadyExists: 'កំណត់ត្រាត្រួតពិនិត្យអាហារមានរួចហើយសម្រាប់ម៉ឺនុយនេះ។',
    foodInspectionNotFound: 'មិនមានកំណត់ត្រាត្រួតពិនិត្យអាហារជាក់លាក់ទេ។',
    annualEventNotFound: 'ព្រឹត្តិការណ៍ប្រចាំឆ្នាំដែលបានបញ្ជាក់មិនមានទេ។',
    classIdNotOwned: 'លេខសម្គាល់ថ្នាក់ដែលបានបញ្ជាក់មិនមែនជាកម្មសិទ្ធិរបស់មណ្ឌលបណ្តុះកូននេះទេ។',
    invalidSocketId: 'ទម្រង់ SocketId មិនត្រឹមត្រូវទេ។ សូមទាក់ទងអ្នកគ្រប់គ្រងប្រព័ន្ធ។',
    napCheckPatternNotFound: 'លំនាំពិនិត្យពេលគេងមិនមានទេ។',
    duplicateStaff: 'បុគ្គលិកដែលត្រូវបានចាត់តាំងត្រូវបានចម្លង។',
    staffNotInNursery: 'បុគ្គលិកដែលបានបញ្ជាក់មិនមែនជាកម្មសិទ្ធិរបស់មណ្ឌលបណ្តុះកូននេះទេ។',
    napPatternNotOwned: 'គំរូពិនិត្យការគេងនេះមិនមែនជាកម្មសិទ្ធិរបស់កន្លែងបណ្តុះកូននេះទេ។',
    childNotInNursery: 'កុមារនេះមិនមែនជាកម្មសិទ្ធិរបស់សាលាមត្តេយ្យនេះទេ។',
    napCheckNotFound: 'ការពិនិត្យពេលគេងមិនមានទេ។',
    napCheckNotOwned: 'ការត្រួតពិនិត្យការគេងនេះមិនមែនជាកម្មសិទ្ធិរបស់មណ្ឌលបណ្តុះកូននេះទេ។',
    napCheckTempHumidityNotFound: 'ទិន្នន័យសីតុណ្ហភាព/សំណើមសម្រាប់ការត្រួតពិនិត្យការគេងនេះមិនមានទេ។',
    napCheckNotPending: 'កំណត់ត្រាពិនិត្យការគេងនេះមិនស្ថិតក្នុងស្ថានភាពរង់ចាំទេ។',
    childAlreadyInNapCheck: 'កុមារ​ដែល​មាន​នៅ​ក្នុង​កំណត់​ត្រា​ពិនិត្យ​ការ​គេង​នេះ​មិន​អាច​បញ្ជាក់​បាន​ទេ។',
    childNotInNapCheck: 'កុមារដែលមិននៅក្នុងកំណត់ត្រាពិនិត្យការគេងនេះមិនអាចបញ្ជាក់បានទេ។',
    staffAlreadyInNapCheck: 'បុគ្គលិក​ដែល​មាន​ស្រាប់​ក្នុង​កំណត់​ត្រា​ពិនិត្យ​ការ​គេង​នេះ​មិន​អាច​បញ្ជាក់​បាន​ទេ។',
    napCheckCannotEdit: 'មិន​អាច​កែសម្រួល​កំណត់​ត្រា​ពិនិត្យ​ពេល​បាន​បញ្ចប់ ឬ​កំពុង​រង់ចាំ​បាន​ទេ។',
    napCheckDetailNotFound: 'កំណត់​ត្រា​ឯក​ជន​ដែល​បាន​បញ្ជាក់​ថា​មិន​មាន។',
    napCheckDetailNotOwned: 'កំណត់​ត្រា​ឯកត្តជន​ដែល​បាន​បញ្ជាក់​ថា​មិន​មែន​ជា​របស់​មណ្ឌល​បណ្តុះ​កូន​នេះ​ទេ។',
    napCheckDetailAlreadyExists: 'កំណត់​ត្រា​ពិនិត្យ​ការ​គេង​ដែល​បាន​បញ្ជាក់​មាន​រួច​ហើយ។',
    childNotInNapCheck2: 'កុមារដែលបានបញ្ជាក់មិនត្រូវបានរាប់បញ្ចូលក្នុងការត្រួតពិនិត្យការគេងនេះទេ។',
    invalidEventTime: 'ការកំណត់ពេលវេលាព្រឹត្តិការណ៍មិនត្រឹមត្រូវទេ។',
    noRelation: 'គ្មានទំនាក់ទំនង។',
    napSensorNotFound: 'ឧបករណ៍ចាប់សញ្ញាពេលយប់មិនមានទេ។',
    commentLimit: 'មតិយោបល់ត្រូវតែមានក្នុង 1000 តួអក្សរ។',
    absenceConfirmationFailed: 'បរាជ័យក្នុងការបញ្ជាក់អវត្តមាន។',
    pickupChangeConfirmationFailed: 'បរាជ័យក្នុងការបញ្ជាក់ការផ្លាស់ប្តូរការទទួល។',
    invalidEventPeriod: 'ការកំណត់រយៈពេលព្រឹត្តិការណ៍មិនត្រឹមត្រូវទេ។',
    guardianNotFound: 'រកមិនឃើញអាណាព្យាបាលទេ។',
    duplicateAllergyFood: 'អាហារអាឡែរហ្សីដែលមានឈ្មោះដូចគ្នាត្រូវបានចុះឈ្មោះរួចហើយ។',
    allergyFoodNotOwned: 'អាហារអាឡែហ្ស៊ីដែលបានបញ្ជាក់មិនមែនជាកម្មសិទ្ធិរបស់កន្លែងបណ្តុះកូននេះទេ។',
    staffAccountTitleExists: 'ចំណងជើងគណនីបុគ្គលិកមានរួចហើយ។',
    staffAccountTitleNotFound: 'មិនមានចំណងជើងគណនីបុគ្គលិកទេ។',
    staffAccountInfoExists: 'ព័ត៌មានគណនីបុគ្គលិកមានរួចហើយ។',
    staffAccountInfoNotFound: 'ព័ត៌មានគណនីបុគ្គលិកមិនមានទេ។',
    staffTitleInUse: 'ចំណងជើងគណនីបុគ្គលិកនេះមិនអាចលុបបានទេ ដោយសារវាកំពុងប្រើបច្ចុប្បន្ន។',
    endDateBeforeStartDate: 'កាលបរិច្ឆេទបញ្ចប់ត្រូវបានកំណត់បន្ទាប់ពីកាលបរិច្ឆេទចាប់ផ្តើម។',
    pastDateTime: 'កាលបរិច្ឆេទ/ពេលវេលាដែលបានបញ្ជាក់គឺនៅអតីតកាល។',
    excelGenerationFailed: 'បរាជ័យក្នុងការបង្កើតឯកសារ Excel ។ សូមទាក់ទងអ្នកគ្រប់គ្រងប្រព័ន្ធ។',
    napSensorNotStarted: 'ឧបករណ៍ចាប់សញ្ញាពេលគេងមិនចាប់ផ្តើមទេ។',
    napSensorRecordNotFound: 'រកមិនឃើញកំណត់ត្រាឧបករណ៍ចាប់សញ្ញាពេលគេងទេ។',
    absenceRegistrationNotFound: 'ការចុះឈ្មោះអវត្តមានត្រូវបានរកឃើញ។',
    chatReadOnly: 'ការជជែកដែលបង្កើតដោយអ្នកផ្សេងអាចមើលបានប៉ុណ្ណោះ។',
    emailInUse: 'អាសយដ្ឋានអ៊ីមែលដែលបានបញ្ជាក់មិនអាចផ្លាស់ប្តូរបានទេព្រោះវាកំពុងត្រូវបានប្រើប្រាស់ដោយអ្នកប្រើប្រាស់ផ្សេងទៀត។',
    attachmentNotFound: 'រកមិនឃើញឯកសារភ្ជាប់ទេ។',
    certificationNotFound: 'វិញ្ញាបនប័ត្រ/កំណត់ត្រាថ្លៃថែទាំកុមារមិនមានទេ។',
    certificationEndDateRequired: 'សូមបញ្ចូលកាលបរិច្ឆេទបញ្ចប់ការបញ្ជាក់។',
    certificationPeriodOverlap: 'វិញ្ញាបនប័ត្រ/ការបញ្ជាក់រយៈពេលថ្លៃសេវាថែទាំកុមារមិនត្រឹមត្រូវទេ។ សូមពិនិត្យមើលការត្រួតស៊ីគ្នាជាមួយនឹងរយៈពេលផ្សេងទៀត។',
    accountTitleNotFound: 'រកមិនឃើញចំណងជើងគណនីគោលដៅទេ។',
    accountTitleInUse: 'ចំណងជើងគណនីមិនអាចលុបបានទេព្រោះវាត្រូវបានប្រើក្នុងកំណត់ត្រាសាច់ប្រាក់តិចតួច។',
    pettyCashDetailNotFound: 'រកមិនឃើញកំណត់ត្រាសាច់ប្រាក់តូចតាចទេ។',
    duplicateAllergyItem: 'ធាតុអាឡែហ្ស៊ីដែលមានឈ្មោះដូចគ្នាត្រូវបានចុះឈ្មោះរួចហើយ។',
    allergyItemNotFound: 'រកមិនឃើញធាតុអាឡែរហ្សី។',
    allergyItemCannotModify: 'ធាតុអាឡែហ្ស៊ីដែលបានបញ្ជាក់មិនអាចលុប ឬធ្វើបច្ចុប្បន្នភាពបានទេ។',
    menuTypeNotFound: 'រកមិនឃើញប្រភេទម៉ឺនុយទេ។',
    menuNotFound: 'រកមិនឃើញម៉ឺនុយ។',
    foodInspectionNotFound2: 'រកមិនឃើញការត្រួតពិនិត្យអាហារ។',
    foodInspectionAlreadyCreated: 'ការត្រួតពិនិត្យអាហារត្រូវបានបង្កើតឡើងរួចហើយ។',
    extendedCarePatternNotFound: 'រកមិនឃើញគំរូថែទាំបន្ថែមទេ។',
    timeSlotOverlap: 'មិនអាចរក្សាទុកបានទេ ដោយសារពេលវេលាត្រួតគ្នា',
    timeSlotNotFound: 'រកមិនឃើញចន្លោះពេលទេ។',
    timeStampSettingNotFound: 'ការកំណត់ពេលវេលាមិនមានទេ។',
    extendedCareDiaryNotOwned: 'កំណត់ហេតុថែទាំបន្ថែមដែលបានបញ្ជាក់មិនមែនជាកម្មសិទ្ធិរបស់មណ្ឌលថែទាំនេះទេ។',
    nurseryServiceNotRegistered: 'សេវាបណ្តុះកូនដែលបានបញ្ជាក់មិនត្រូវបានចុះឈ្មោះនៅក្នុងមេទេ។',
    nurseryServiceAlreadyRegistered: 'សេវាបណ្តុះកូនដែលបានបញ្ជាក់ត្រូវបានចុះឈ្មោះរួចហើយ។',
    nurseryServiceNotEnrolled: 'សេវាបណ្តុះកូនដែលបានបញ្ជាក់មិនត្រូវបានចុះឈ្មោះទេ។',
    monthlyServiceSetDate: 'សម្រាប់សេវាកម្មបរិក្ខារប្រើប្រាស់ប្រចាំខែ សូមកំណត់ថ្ងៃទី 1 នៃខែជាកាលបរិច្ឆេទប្រើប្រាស់។',
    nurseryServiceInUse: 'សេវាកម្មដែលផ្តល់ដោយបរិក្ខារដែលបានបញ្ជាក់មិនអាចលុបបានទេព្រោះវាកំពុងប្រើប្រាស់។',
    invalidServiceType: 'ទម្រង់​ប្រភេទ​សេវាកម្ម​នៃ​សេវា​ដែល​ផ្តល់​ដោយ​ឧបករណ៍​មិន​ត្រឹមត្រូវ​ទេ។',
    invalidPaymentMonthType: 'ទម្រង់បង់ប្រាក់ប្រចាំខែនៃសេវាកម្មដែលផ្តល់ដោយមធ្យោបាយគឺមិនត្រឹមត្រូវទេ។',
    invalidAccountType: 'ទម្រង់​ប្រភេទ​គណនី​នៃ​សេវា​ដែល​ផ្តល់​ដោយ​ឧបករណ៍​មិន​ត្រឹមត្រូវ​ទេ។',
    userNotInManagementCompany: 'អ្នកប្រើប្រាស់មិនមែនជាកម្មសិទ្ធិរបស់ក្រុមហ៊ុនគ្រប់គ្រងដែលបានបញ្ជាក់នោះទេ។',
    managementCompanyNotFound: 'រកមិនឃើញក្រុមហ៊ុនគ្រប់គ្រងទេ។',
    invoiceNotFound: 'វិក្កយបត្រដែលបានបញ្ជាក់មិនមានទេ។',
    invalidInvoiceStatus: 'ស្ថានភាពវិក្កយបត្រមិនត្រឹមត្រូវទេ។',
    invoiceNotConfirmed: 'វិក្កយបត្រមិនទាន់ត្រូវបានបញ្ជាក់នៅឡើយទេ។',
    fileReadFailed: 'បរាជ័យក្នុងការអានឯកសារ។ សូមពិនិត្យមើលទម្រង់ឯកសារ CSV ។',
    invalidChildCode: 'លេខកូដកូននៅក្នុងឯកសារ CSV មិនត្រឹមត្រូវទេ។',
    invalidReceivableValue: 'តម្លៃដែលអាចទទួលយកបាននៅក្នុងឯកសារ CSV គឺមិនត្រឹមត្រូវទេ។',
    receivableImportNotFound: 'មិនមានស្ថានភាពនាំចូលសមតុល្យដែលអាចទទួលបានទេ។',
    salesInfoSentCannotEdit: 'កំណត់ត្រាការមកដល់/ចេញដំណើរនេះមិនអាចកែសម្រួលបានទេ ដោយសារព័ត៌មានលក់សម្រាប់ខែនេះត្រូវបានផ្ញើ។',
    pettyCashConfirmedCannotChange: 'កំណត់ត្រាសាច់ប្រាក់តិចតួចដែលបានបញ្ជាក់មិនអាចផ្លាស់ប្តូរបានទេ។',
    salesConfirmedCannotEdit: 'ព័ត៌មានអំពីថ្លៃសេវាថែទាំកុមារ/វិញ្ញាបនបត្រសម្រាប់រយៈពេល រួមទាំងរយៈពេលគោលដៅមិនអាចកែសម្រួលបានទេ ដោយសារព័ត៌មានលក់ត្រូវបានបញ្ជាក់។',
    otherServiceDetailNotFound: 'ព័ត៌មានលម្អិតនៃសេវាកម្មផ្សេងទៀតដែលបានបញ្ជាក់មិនមានទេ។',
    childWithoutCertification: 'មានកុមារដែលមិនមានថ្លៃថែទាំកុមារ/ព័ត៌មានវិញ្ញាបនប័ត្រដែលបានចុះឈ្មោះ។ សូមកំណត់ពួកវាមុនពេលផ្ញើ។',
    managementCompanyServiceNotFound: 'ការកំណត់សេវាកម្មរបស់ក្រុមហ៊ុនគ្រប់គ្រងមិនមានទេ។',
    insufficientPermission: 'ដោយសារការអនុញ្ញាតមិនគ្រប់គ្រាន់ ស្ថានភាពបញ្ជាក់សាច់ប្រាក់តូចមិនអាចត្រូវបញ្ចេញបានទេ។',
    notDraftStatus: 'មិន​អាច​ធ្វើ​ប្រតិបត្តិការ​បាន​ទេ ព្រោះ​ស្ថានភាព​មិន​មែន​ជា​សេចក្តីព្រាង។',
    salesConfirmedCannotEdit2: 'សេវាកម្មដែលផ្តល់ដោយបណ្តុះកូនសម្រាប់រយៈពេល រួមទាំងកំឡុងពេលគោលដៅមិនអាចកែសម្រួលបានទេ ដោយសារព័ត៌មាននៃការលក់ត្រូវបានបញ្ជាក់។',
    nurseryAccountNotFound: 'រកមិនឃើញការកំណត់គណនីផ្ទេរកុមារទេ។',
    childAlreadyWithdrawn: 'កុមារនេះបានដកខ្លួនចេញហើយ។',
    discussionNotFound: 'រកមិនឃើញការពិភាក្សាដែលបានបញ្ជាក់។',
    invalidGmoCardToken: 'និមិត្តសញ្ញាកាត GMO មិនត្រឹមត្រូវទេ។',
    cardRegistrationFailed: 'កំហុសបានកើតឡើងអំឡុងពេលចុះឈ្មោះកាត។ សូមពិនិត្យមើលព័ត៌មានកាត។',
    gmoCardNotFound: 'រកមិនឃើញព័ត៌មានកាត GMO ។',
    gmoCardDeleteFailed: 'កំហុសបានកើតឡើងខណៈពេលកំពុងលុបកាត GMO ។',
    fileTooLarge: 'ឯកសារមិនអាចផ្ញើបានទេព្រោះវាលើសពី 10MB។',
    emailNotVerified: 'អ៊ីមែលមិនត្រូវបានផ្ទៀងផ្ទាត់ទេ។ សូមពិនិត្យមើលអ៊ីមែលរបស់អ្នក។',
    internalServerError: 'កំហុសម៉ាស៊ីនមេខាងក្នុង',
    noDetailedErrorMessage: 'គ្មាន​សារ​បញ្ហា​លម្អិត​អាច​ប្រើ​បាន​ទេ។',
    emailNotAvailable: 'អាសយដ្ឋានអ៊ីមែលនេះមិនមានទេ។',
  },
};
